export default "__VITE_ASSET__e76e0ba7__"